function globalLogin() {
  let agcustId = localStorage.getItem("personid");
  if (agcustId == null) {
    this.$router.push({
      path: "/login",
    });
  }
}

export default {
  globalLogin,
}